import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 Siden blev ikke fundet - Recars ApS</title>
        <meta name="description" content="Siden blev ikke fundet." />
      </Helmet>

      <section className="relative min-h-screen flex items-center justify-center bg-dark-950 px-4">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(197,168,128,0.05),transparent_50%)]" />
        
        <div className="relative z-10 text-center max-w-md mx-auto">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#c5a880]/10 border border-[#c5a880]/20 text-[#c5a880] mx-auto mb-8">
            <i className="fa-solid fa-compass-slash text-3xl animate-spin-slow" />
          </div>
          
          <h1 className="font-display text-4xl font-extrabold text-white tracking-tight sm:text-5xl">
            404
          </h1>
          <h2 className="mt-4 font-display text-lg font-bold text-[#c5a880] uppercase tracking-wider">
            Siden er kørt af sporet
          </h2>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Den side, du leder efter, findes desværre ikke eller er blevet flyttet. Brug knapperne nedenfor til at navigere tilbage til bilhuset.
          </p>
          
          <div className="mt-10 flex justify-center gap-4">
            <Link
              to="/"
              className="rounded-xl bg-[#c5a880] px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-black hover:bg-[#b39368] transition-all duration-300"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/biler-til-salg"
              className="rounded-xl border border-dark-700 bg-dark-900 px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-white hover:bg-dark-800 transition-all duration-300"
            >
              Se lagerbiler
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
